<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="validate">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>perm_identity</md-icon>
          </div>
          <h4 class="title">
            Actualización de datos - <small>{{ getName() }}</small>
          </h4>
        </md-card-header>

        <md-card-content v-if="myAccount">
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-33">
              <md-field>
                <md-icon>picture_in_picture_alt</md-icon>
                <label>Documento: {{ myAccount.documentValue }}</label>
                <md-input disabled></md-input>
              </md-field>
            </div>

            <div
              class="md-layout-item md-size-33 md-small-size-100"
              v-if="!isAdmin() && myAccount.capProfile"
            >
              <ValidationProvider
                name="phoneNumber"
                rules="max_value:9999999|min_value:1000000"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': true }
                  ]"
                >
                  <md-icon>phone</md-icon>
                  <label
                    >Teléfono: {{ myAccount.capProfile.phoneNumber }}</label
                  >
                  <md-input v-model="phoneNumber" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div
              v-if="isAdmin()"
              class="md-layout-item md-size-33 ml-auto md-small-size-100"
            >
              <ValidationProvider
                name="email"
                rules="email"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': true }
                  ]"
                >
                  <md-icon>email</md-icon>
                  <label>Email: {{ myAccount.email }}</label>
                  <md-input v-model="email" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-33 md-small-size-100">
              <ValidationProvider
                name="cellphone"
                rules="max_value:3999999999|min_value:3000000000"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': true }
                  ]"
                >
                  <md-icon>phone</md-icon>
                  <label>Celular: {{ myAccount.cellphone }}</label>
                  <md-input v-model="cellphone" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div
              class="md-layout-item md-size-50 md-small-size-100"
              v-if="!isAdmin() && myAccount.capProfile"
            >
              <ApolloQuery
                :query="require('../../graphql/query/DomainGroup.gql')"
                :variables="{ fieldName: Constants.DOMAIN_INCOME_SALARY }"
                ><template v-slot="{ result: { data } }">
                  <ValidationProvider
                    name="capDomainIncomeSalary"
                    v-slot="{ passed, failed }"
                  >
                    <md-field
                      :class="[
                        { 'md-error': failed },
                        { 'md-valid': passed },
                        { 'md-form-group': true }
                      ]"
                    >
                      <md-icon>picture_in_picture</md-icon>
                      <label for="select"
                        >Ingresos Mensuales:
                        {{
                          myAccount.capProfile.capDomainIncomeSalary.fieldValue
                        }}</label
                      >
                      <md-select
                        v-if="data"
                        v-model="capDomainIncomeSalary"
                        name="select"
                      >
                        <md-option value="">Sin Cambiar</md-option>
                        <md-option
                          v-for="docType in data.getDomain"
                          :key="docType.id"
                          :value="docType.id"
                          >{{ docType.value }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </ValidationProvider>
                </template>
              </ApolloQuery>
            </div>
            <div
              class="md-layout-item md-size-50 md-small-size-100"
              v-if="!isAdmin() && myAccount.capProfile"
            >
              <ApolloQuery
                :query="require('../../graphql/query/DomainGroup.gql')"
                :variables="{ fieldName: Constants.DOMAIN_EXPENSES }"
                ><template v-slot="{ result: { data } }">
                  <ValidationProvider
                    name="capDomainMonthlyExpenses"
                    v-slot="{ passed, failed }"
                  >
                    <md-field
                      :class="[
                        { 'md-error': failed },
                        { 'md-valid': passed },
                        { 'md-form-group': true }
                      ]"
                    >
                      <md-icon>picture_in_picture</md-icon>
                      <label for="select"
                        >Gastos Mensuales:
                        {{
                          myAccount.capProfile.capDomainMonthlyExpenses
                            .fieldValue
                        }}</label
                      >
                      <md-select
                        v-if="data"
                        v-model="capDomainMonthlyExpenses"
                        name="select"
                      >
                        <md-option value="">Sin Cambiar</md-option>
                        <md-option
                          v-for="docType in data.getDomain"
                          :key="docType.id"
                          :value="docType.id"
                          >{{ docType.value }}</md-option
                        >
                      </md-select>
                    </md-field>
                  </ValidationProvider>
                </template>
              </ApolloQuery>
            </div>
            <div
              v-if="!isAdmin() && myAccount.capProfile"
              class="md-layout-item md-small-size-100 md-size-50"
            >
              <ValidationProvider name="department" v-slot="{ passed, failed }">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>room</md-icon>
                  <label
                    >Departamento de residencia:
                    {{
                      myAccount.capProfile.capCityResidence.capDepartment
                        .depName
                    }}</label
                  >
                  <md-select
                    v-if="departments"
                    v-model="departmentId"
                    name="select"
                  >
                    <md-option :value="null" disabled
                      >Seleccionar Departamento</md-option
                    >
                    <md-option
                      v-for="department in departments"
                      :key="department.id"
                      :value="department.id"
                      >{{ department.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <div
              class="md-layout-item md-size-50 md-small-size-100"
              v-if="!isAdmin() && myAccount.capProfile"
            >
              <ValidationProvider
                name="capCityResidence"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  v-if="department.cities"
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>room</md-icon>
                  <label
                    >Ciudad de residencia:
                    {{ myAccount.capProfile.capCityResidence.cityName }}</label
                  >
                  <md-select v-model="capCityResidence" name="select">
                    <md-option
                      v-for="city in department.cities"
                      :key="city.id"
                      :value="city.id"
                      >{{ city.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <AdressPicker
              v-if="!isAdmin() && myAccount.capProfile"
              class="md-layout-item md-size-100"
              @residenceAddress="fillAddress"
            />
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="password"
                rules="confirmed:passConfirmation|min:6"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Actualizar Contraseña</label>
                  <md-input v-model="password" type="password"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                vid="passConfirmation"
                rules="min:6"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Confirmar Contraseña</label>
                  <md-input v-model="passConfirmation" type="password">
                  </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button
                :disabled="loading"
                @click="updateInfo()"
                class="md-raised md-success mt-4"
                >Actualizar</md-button
              >
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import gql from "graphql-tag";
import AdressPicker from "../components/AdressPicker.vue";
import Constants from "../../constants";
import { extend } from "vee-validate";
import { SlideYDownTransition } from "vue2-transitions";
import { max_value, min_value, required } from "vee-validate/dist/rules";
import Swal from "sweetalert2";

extend("max_value", max_value);
extend("required", required);
extend("min_value", min_value);
export default {
  name: "edit-profile-form",
  components: {
    SlideYDownTransition,
    AdressPicker
  },
  props: {
    headerColor: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      myAccount: null,
      capDomainIncomeSalary: null,
      capDomainMonthlyExpenses: null,
      phoneNumber: null,
      loading: false,
      email: null,
      fullName: null,
      residenceAddress: null,
      capCityResidence: null,
      country: null,
      code: null,
      password: null,
      passConfirmation: "",
      statusList: null,
      cellphone: null,
      department: {},
      departmentId: null,
      departments: [],
      Constants: Constants
    };
  },
  methods: {
    fillAddress(value) {
      this.residenceAddress = value;
    },
    isAdmin() {
      return Constants.getUserType() == Constants.ADMIN;
    },
    updateInfo() {
      return this.$refs.form.validate().then(res => {
        if (res) {
          if (
            this.phoneNumber ||
            this.cellphone ||
            this.capDomainIncomeSalary ||
            this.capDomainMonthlyExpenses ||
            this.capCityResidence ||
            this.residenceAddress ||
            this.password ||
            this.email
          ) {
            Swal.fire({
              title: "Confirmación de actualización",
              text: this.buildConfirmationMessage(),
              type: "warning",
              showCancelButton: true,
              confirmButtonClass: "md-button md-primary",
              cancelButtonClass: "md-button md-info",
              confirmButtonText: "Sí",
              cancelButtonText: "No",
              buttonsStyling: false
            }).then(result => {
              if (result.value) {
                this.loading = true;
                var message = "Tipo de información actualizada: ";
                var isFirst = true;
                if (this.isAdmin())
                  this.$apollo
                    .mutate({
                      mutation: gql`
                        mutation updatePersonalInformationAsAdmin(
                          $documentValue: String!
                          $email: String
                          $password: String
                          $cellphone: String
                        ) {
                          updatePersonalInformationAsAdmin(
                            documentValue: $documentValue
                            email: $email
                            password: $password
                            cellphone: $cellphone
                          )
                        }
                      `,
                      variables: {
                        documentValue: this.myAccount.documentValue,
                        email: this.email,
                        password: this.password,
                        cellphone: this.cellphone
                      },
                      update: (cache, mutationResult) => {
                        this.loading = false;
                        let updateSomething =
                          mutationResult.data.updatePersonalInformationAsAdmin;
                        if (updateSomething) {
                          if (isFirst) isFirst = false;
                          else message += ", ";
                          message += "Cuenta";
                        }
                        Swal.fire({
                          title: "Usuario actualizado",
                          text: message + ".",
                          confirmButtonClass: "md-button md-primary",
                          buttonsStyling: false
                        }).then(() => {
                          this.$router.go();
                        });
                      }
                    })
                    .catch(error => {
                      this.loading = false;
                      Constants.catchError(
                        error,
                        this.$apollo.provider.defaultClient,
                        this,
                        false
                      );
                    });
                else
                  this.$apollo
                    .mutate({
                      mutation: gql`
                        mutation updateProfileInformation(
                          $documentValue: String!
                          $residenceAddress: String
                          $capCityResidence: Int
                          $phoneNumber: String
                          $capDomainIncomeSalary: Int
                          $capDomainMonthlyExpenses: Int
                        ) {
                          updateProfileInformation(
                            documentValue: $documentValue
                            residenceAddress: $residenceAddress
                            capCityResidence: $capCityResidence
                            phoneNumber: $phoneNumber
                            capDomainIncomeSalary: $capDomainIncomeSalary
                            capDomainMonthlyExpenses: $capDomainMonthlyExpenses
                          )
                        }
                      `,
                      variables: {
                        documentValue: this.myAccount.documentValue,
                        residenceAddress: this.residenceAddress,
                        capCityResidence: this.capCityResidence,
                        phoneNumber: this.phoneNumber,
                        capDomainIncomeSalary: this.capDomainIncomeSalary,
                        capDomainMonthlyExpenses: this.capDomainMonthlyExpenses
                      },
                      update: (cache, mutationResult) => {
                        let updateSomething =
                          mutationResult.data.updateProfileInformation;
                        if (updateSomething) {
                          isFirst = false;
                          message += "Perfil";
                        }
                        this.$apollo
                          .mutate({
                            mutation: gql`
                              mutation updatePersonalInformationAsClient(
                                $documentValue: String!
                                $password: String
                                $cellphone: String
                              ) {
                                updatePersonalInformationAsClient(
                                  documentValue: $documentValue
                                  password: $password
                                  cellphone: $cellphone
                                )
                              }
                            `,
                            variables: {
                              documentValue: this.myAccount.documentValue,
                              password: this.password,
                              cellphone: this.cellphone
                            },
                            update: (cache, mutationResult) => {
                              this.loading = false;
                              updateSomething =
                                mutationResult.data
                                  .updatePersonalInformationAsClient;
                              if (updateSomething) {
                                if (isFirst) isFirst = false;
                                else message += ", ";
                                message += "Cuenta";
                              }
                              Swal.fire({
                                title: "Usuario actualizado",
                                text: message + ".",
                                confirmButtonClass: "md-button md-primary",
                                buttonsStyling: false
                              }).then(() => {
                                this.$router.go();
                              });
                            }
                          })
                          .catch(error => {
                            this.loading = false;
                            Constants.catchError(
                              error,
                              this.$apollo.provider.defaultClient,
                              this,
                              false
                            );
                          });
                      }
                    })
                    .catch(error => {
                      this.loading = false;
                      Constants.catchError(
                        error,
                        this.$apollo.provider.defaultClient,
                        this,
                        false
                      );
                    });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
              }
            });
          } else
            Swal.fire({
              title: "No hay cambios",
              text: "Modifica el/los datos que deseas actualizar",
              timer: 2000,
              showConfirmButton: false
            });
        }
      });
    },
    buildConfirmationMessage() {
      var message = "¿Seguro que deseas actualizar el/los campo(s) ";
      var isFirst = true;
      if (this.email) {
        message += "Correo";
        isFirst = false;
      }
      if (this.phoneNumber) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Teléfono";
      }
      if (this.cellphone) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Celular";
      }
      if (this.capDomainIncomeSalary) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Ingresos Mensuales";
      }
      if (this.capDomainMonthlyExpenses) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Gastos Mensuales";
      }
      if (this.capCityResidence) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Ciudad de Residencia";
      }
      if (this.residenceAddress) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Dirección de residencia";
      }
      if (this.password) {
        if (!isFirst) message += ", ";
        else isFirst = false;
        message += "Contraseña";
      }
      return message + "?";
    },

    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    getName() {
      return Constants.getUserFullName();
    }
  },
  watch: {
    departmentId() {
      this.department = this.departments.filter(obj => {
        return obj.id === this.departmentId;
      })[0];
    }
  },
  mounted() {
    this.$apollo
      .query({
        query: gql`
          query departments {
            departments {
              id: depId
              name: depName
              cities: capCities {
                id: cityId
                name: cityName
              }
            }
          }
        `
      })
      .then(data => {
        this.departments = data.data.departments;
      })
      .catch(error => {
        Constants.catchError(
          error,
          this.$apollo.provider.defaultClient,
          this,
          false
        );
      });
    this.$apollo
      .query({
        query: gql`
          query findAccoundById($id: Int!) {
            findAccountById(id: $id) {
              fullName
              email
              cellphone

              capProfile {
                capDomainIncomeSalary {
                  domId
                  fieldValue
                }
                capDomainMonthlyExpenses {
                  domId
                  fieldValue
                }
                residenceAddress
                capClientJobs {
                  clientJobId
                  enterpriseEmail
                  enterpriseName
                  enterpriseNit
                  enterprisePhone
                  enterprisePhoneExt
                  jobRole
                  yearsExperience
                }

                capCityResidence {
                  cityName
                  capDepartment {
                    depName
                  }
                }

                phoneNumber
              }
              documentValue
            }
          }
        `,
        variables: {
          id: Constants.getUserId()
        }
      })
      .then(data => {
        this.myAccount = data.data.findAccountById;
      })
      .catch(error => {
        Constants.catchError(
          error,
          this.$apollo.provider.defaultClient,
          this,
          false
        );
      });
    this.$apollo
      .query({
        query: gql`
          query getStatus($type: String!) {
            getStatus(type: $type) {
              id: stateId
              name: stateName
              description: stateDescription
            }
          }
        `,
        variables: {
          type: "1"
        }
      })
      .then(data => {
        this.statusList = data.data.getStatus;
      })
      .catch(error => {
        Constants.catchError(
          error,
          this.$apollo.provider.defaultClient,
          this,
          false
        );
      });
  }
};
</script>
<style></style>
